/**
 * Gestion des sous-traitants au bureau : adresses, droits d'accès aux écrans
 * (le serveur revérifie, site compris) et libellés partagés.
 */
import { t } from '../../../core/i18n.js';

export const SUBCONTRACTORS_PATH = '/entreprise/sous-traitants';
export const subcontractorPath = (id: string): string => `${SUBCONTRACTORS_PATH}/${id}`;
export const subcontractingPath = (interventionId: string): string => `/interventions/${interventionId}/sous-traitance`;

/** Confier une intervention ou reprendre une contribution (site vérifié par l'API). */
export const MISSION_CAPABILITIES = ['intervention.create_any', 'planning.edit_all'] as const;
/** Voir la liste : gérer les comptes ou confier des missions. */
export const OFFICE_CAPABILITIES = ['users.manage', ...MISSION_CAPABILITIES] as const;

export type AccountStatus = 'invite' | 'actif' | 'revoque';

export interface SubcontractorRow {
  id: string;
  company_name: string;
  contact_name: string;
  email: string;
  phone: string | null;
  status: AccountStatus;
  invite_expires_at: string | null;
  active_missions: number;
}

export interface GrantRights {
  canReport: boolean;
  canTime: boolean;
  canMedia: boolean;
  canSignature: boolean;
}

export type RightKey = keyof GrantRights;
export const RIGHT_KEYS: readonly RightKey[] = ['canReport', 'canTime', 'canMedia', 'canSignature'];

export function rightsOf(row: { can_report: boolean; can_time: boolean; can_media: boolean; can_signature: boolean }): GrantRights {
  return { canReport: row.can_report, canTime: row.can_time, canMedia: row.can_media, canSignature: row.can_signature };
}

export function rightKeyLabel(key: RightKey): string {
  return t(`sousTraitant.bureau.droits.${key}`);
}

/** « Compte rendu, temps » : les droits accordés, dans l'ordre de la saisie. */
export function rightsSummary(rights: GrantRights): string {
  return RIGHT_KEYS.filter((key) => rights[key]).map(rightKeyLabel).join(', ');
}

export function statusLabel(status: AccountStatus): string {
  return t(`sousTraitant.bureau.statuts.${status}`);
}

export function statusTone(status: AccountStatus): 'ok' | 'warn' | 'neutral' {
  return status === 'actif' ? 'ok' : status === 'invite' ? 'warn' : 'neutral';
}
